<div
  class="border-1 border-round border-round-3xl status-badge px-3 py-2 font-semibold status-text text-module-title border-round-3xl text-lg"
  [ngClass]="className"
>
  {{ statusLabel | translate }}
</div>
